// The UserMenu component displays a user avatar button which opens a
// dropdown containing account links.  When no user is logged in it
// renders a Sign In button.  For admins an additional set of admin
// navigation links is displayed, including a new Reports entry to
// access the admin reports page.  Sign out triggers the logout hook.

'use client';

import { Button } from '@/components/ui/button';
import { DotIcon, Loader2, User } from 'lucide-react';
import { useUser as useClerkUser } from '@clerk/nextjs';
import { SignInButton, UserButton } from '@clerk/nextjs';

export function UserMenu() {
  const { isLoaded, user: clerkUser } = useClerkUser();

  // Show a spinner only when Clerk is loading
  if (!isLoaded) {
    return <Loader2 className="h-4 w-4 animate-spin" />;
  }

  // If there is no authenticated user render Clerk's SignInButton
  if (!clerkUser) {
    return (
      <SignInButton mode="modal">
        <Button
          variant="ghost"
          className="flex flex-col items-center gap-1 h-auto py-2 px-3 min-h-[44px] min-w-[44px] sm:min-h-[40px] sm:min-w-[40px]"
        >
          <User className="h-5 w-5 sm:h-4 sm:w-4" />
          <span className="text-xs sm:text-[10px] leading-tight">Sign In</span>
        </Button>
      </SignInButton>
    );
  }

  // When a user is logged in, show Clerk's UserButton with custom dropdown
  return (
    <div className="flex items-center gap-2">
      <UserButton 
        appearance={{
          elements: {
            avatarBox: "h-8 w-8",
            userButtonPopoverCard: "w-56"
          }
        }}
        userProfileMode="modal"
      >
        <UserButton.MenuItems>
          <UserButton.Link label="Orders" href="/profile/orders" labelIcon={<DotIcon />} />
          <UserButton.Action label="signOut" />
        </UserButton.MenuItems>
      </UserButton>
    </div>
  );
}